import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  useLocation,
  useParams
} from "react-router-dom/cjs/react-router-dom.min";
import { compose } from "redux";
import { success_subscription } from "services/subscriptionServices";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import navigationAction from "redux/navigation/actions";
import Loader from "components/Loader";
import { checkApi } from "services/authServices";
import authActions from "redux/auth/actions";
const { success, error, toggleSubscribeModal } = navigationAction;
const { check } = authActions;

function SubscriptionSuccess(props) {
  // debugger
  let [loading, setLoading] = useState(false);
  let { token, user, history, check } = props;
  const search = useLocation().search;
  console.log("search", search);
  let params = useParams();
  console.log("params", params);
  console.log("in success page");

  const CheckApi = async () => {
    await checkApi(token).then(res => {
      if (res.success) {
        check(res.data);
        history.push("/subscription");
        setLoading(false);
      } else {
        error(res.message);
        setLoading(false);
      }
    });
  };

  const Success_Subsctiption = async () => {
    console.log("success function called");
    const id = new URLSearchParams(search).get("session_id");
    setLoading(true);
    console.log("session id", id);

    await success_subscription(token, id).then(async res => {
      if (res.success) {
        success(res.message);
        // history.push("/")
        CheckApi();
      } else {
        error(res.message);
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    console.log("inside use effect");
    Success_Subsctiption();
  }, []);

  return <div>{loading && <Loader />}</div>;
}

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken,
    user: state.auth.user
  };
};

export default connect(mapStateToProps, { error, success, check })(
  SubscriptionSuccess
);
